<form [formGroup]="businessProfileFormGroup">
    <h3 class="text-center">
        {{ "Business Info" | translate }}
    </h3>

    <div class="text-center">
        <a
            class="text-secondary"
            href="javascript:void(0)"
            (click)="openDialog()"
            ><u>{{ "disclaimer question" | translate }}</u></a
        >
    </div>
    <p class="py-2 text-muted text-center">
        {{ "disclaimer" | translate }}
    </p>

    <div class="d-flex flex-column my-2">
        <mat-form-field appearance="outline" color="accent">
            <mat-label>Company Name</mat-label>
            <input
                matInput
                placeholder="Enter company name…"
                formControlName="companyName"
                fullNameDirective />

            <mat-error
                *ngIf="
                    businessProfileFormGroup
                        .get('companyName')
                        ?.hasError('required')
                ">
                Please enter your company name.
            </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100" color="accent">
            <mat-label>HST Number</mat-label>
            <input
                matInput
                placeholder="Enter name…"
                formControlName="hstNumber" />
            <mat-error
                *ngIf="
                    businessProfileFormGroup
                        .get('hstNumber')
                        ?.hasError('required')
                ">
                Enter HST number…
            </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100" color="accent">
            <mat-label>Business Rep Full Name</mat-label>
            <input
                matInput
                placeholder="Enter name…"
                formControlName="businessRepName"
                fullNameDirective />
            <mat-error
                *ngIf="
                    businessProfileFormGroup
                        .get('businessRepName')
                        ?.hasError('required')
                ">
                Please enter your business rep full name.
            </mat-error>
        </mat-form-field>
    </div>
    <address-section
        #addressSection
        (sectionChanged)="addressSectionValueChanges()"></address-section>
    <div class="d-flex">
        <button
            type="button"
            class="btn btn-primary rounded-pill text-light m-auto"
            matStepperNext
            [disabled]="!isFormValid"
            [ngClass]="
                isFormValid
                    ? 'btn-background-active'
                    : 'btn-background-inactive'
            "
            type="submit"
            (click)="onSubmit()">
            {{ "Continue" | translate }}
        </button>
    </div>
</form>
